import React, { useMemo } from 'react'
import { useDropzone } from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faDownload, faEye, faFile, faFileExcel, faFileImage, faFilePdf, faFileWord, faTimes } from '@fortawesome/free-solid-svg-icons';
import func from '../../../services/functions';
import DocumentPreview from '../../DocumentPreview';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import mainAxios from '../../../services/mainAxios';

const FILE_SIZE_LIMIT = 5000 * 1024 // 500 KB

const  PayrollAttachments = ({payroll, setPayroll, payrollAttachments,  setPayrollAttachments, disabled }) => {

  const { t, } = useTranslation('translations');
  const [filePreview, setFilePreview] = React.useState(null)
  const fileContainer = React.useRef()

  const { getRootProps, getInputProps } = useDropzone({
    accept: "application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,.pdf,.xlsx,.csv",
    onDrop: async (files) => {
      let newFiles = [];
      let filesExceeded = 0;
  
      for (const file of files) {
        const extension = file.name.split(".").pop().toLowerCase();
  
        // Accept pdf, xlsx, and csv
        if (["pdf", "xlsx", "csv"].includes(extension)) {
          const base64File = await func.toBase64(file);
  
          if (base64File.length * (3 / 4) < FILE_SIZE_LIMIT) {
            newFiles.push({
              file: base64File.substr(base64File.indexOf(",") + 1),
              name: file.name,
              documentType: extension,
              source: "new",
            });
          } else {
            filesExceeded += 1;
          }
        }
      }
  
      if (filesExceeded) {
        toast.warning(
          `${filesExceeded} File${filesExceeded === 1 ? "" : "s"} exceeded the limit! Limit is 5 MB.`,
          { containerId: "all_toast" }
        );
      }
  
      setPayrollAttachments((attachments) => [...attachments, ...newFiles]);
    },
  });
  


  const removeAttachment = (e, attachment, index) => {
    e.preventDefault()
    e.stopPropagation()
    if (attachment.source === 'saved') {
      setPayroll((prevPayroll) => ({
        ...prevPayroll,
        salaryAttachments: [
          ...prevPayroll.salaryAttachments.slice(0, index),
          ...prevPayroll.salaryAttachments.slice(index + 1),
        ],
      }));
    } else {
      const savedCount = payroll?.salaryAttachments?.length || 0;
      const newIndex = index - savedCount;
      setPayrollAttachments((prevAttachments) => [
        ...prevAttachments.slice(0, newIndex),
        ...prevAttachments.slice(newIndex + 1),
      ]);
    }
  }

  const previewFile = (attachment, e,download) => {
    e.stopPropagation()
    e.preventDefault()
    let base64 = attachment?.file
    const fileName = attachment?.name;
    const extension = attachment?.documentType;
    if (base64) {
      if (download) {
        func.downloadFile(base64, extension, fileName);
        return;
      }
      setFilePreview({
        base64,
        name: attachment?.name,
        extension: attachment?.documentType
      })
      setTimeout(() => {
        fileContainer.current.classList.toggle('open')
      }, 0)
    }else{
      mainAxios
        .post("/salary-orders/getSalaryAttachmentBytes", {
          object: "GetFileAttachment",
          value: attachment.id,
        })
        .then((res) => {
          if (res?.status === 200) {
            base64 = res.data.content[0];
            if (download) {
              func.downloadFile(base64, extension, fileName);
              return;
            }
            setFilePreview({
              base64,
              name: attachment.name,
              extension: attachment.documentType,
              loading:false
            });
            setTimeout(() => {
              fileContainer.current.classList.toggle("open");
            }, 100);
          }
        })
        .catch(err=>{
          setFilePreview(null);
        })
    }
  }
  const closePreview = () => {
    setTimeout(() => {
      setFilePreview(null)
    }, 150);
    //console.log({fileContainer})
    fileContainer.current.classList.toggle('open')
  }

  const allAttachments =useMemo(()=>{
    return [...(payroll?.salaryAttachments ?? []).map(att => ({...att, source: 'saved'})),...(payrollAttachments ?? []).map(att => ({...att, source: 'new'}))]
  },[payrollAttachments,payroll.salaryAttachments])


  
  const thumbs =  allAttachments?.map((attachment, index) => {
    const placeholder = (type) => {
      if (type == "pdf") {
        return faFilePdf;
      } else if (type == "jpg" || type == "jpeg" || type == "png") {
        return faFileImage;
      } else if (type == "xlsx") {
        return faFileExcel;
      } else if (type == "docx") {
        return faFileWord;
      } else {
        return faFile;
      }
    }

    return (
      <div key={index} className="atachment d-flex flex-column justify-content-center align-items-center">
          <FontAwesomeIcon size="3x" icon={placeholder(attachment.documentType)} />
          <div className="atachment-name mx-1 text-center">
            {attachment.name}
          </div>
        <div className="d-flex mx-1 mt-3">
          <button
            className="attachment__actions--button bg-primary"
            onClick={(e) => previewFile(attachment, e)}>
            <FontAwesomeIcon icon={faEye} />
          </button>
          {attachment?.id && <button
            className="attachment__actions--button bg-primary"
            onClick={(e) => previewFile(attachment, e,true)}>
            <FontAwesomeIcon icon={faDownload} />
          </button>}
          <button
            className="attachment__actions--button bg-danger"
            onClick={(e) => removeAttachment(e, attachment, index)}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>

    )
  })
  return (
    <div className="card border-0 w-100" id="payroll_attachment">
        <div {...getRootProps({ className: `dropzone ${disabled ? 'dropzone-disabled' : ''}`})} disabled={disabled} >
          <input {...getInputProps()} disabled={disabled} />
          <div style={{color:"#868e96"}}> {t('attachment.allowedFiles')}</div>
          <div style={{color:"#868e96"}}> {t('attachment.maxFileSize')}</div>
        </div>
        <div className="attachment__container d-flex flex-wrap">{thumbs}</div>
        <div className="pdf-container" ref={fileContainer}>
          {filePreview &&
            <div className="pdf-viewer">
              <div className="pdf-overlay" onClick={closePreview} />
              <div className="pdf-content">
                <DocumentPreview filePreview={filePreview} />
              </div>
            </div>
          }
      </div>
    </div>
  )
}

export default  PayrollAttachments